module.exports = __webpack_public_path__ + "img/12-arab.04683867.svg";